import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-success-button',
  templateUrl: './success-button.component.html',
  styleUrls: ['./success-button.component.css']
})
export class SuccessButtonComponent {

  @Input() text: string;
  @Input() icon: string;
  @Input() buttonText: string;
  @Input() disabled: boolean;


  constructor() { }


}
